import axios from '@/axios/index'
import { baseUrl } from '@/config/env'
import { $isInIos, $isXunMengTu } from '@/util/util'
const appType = $isXunMengTu() ? 'xunmengtu_android' : 'android'
const channel = $isXunMengTu() ? ($isInIos() ? 'xunmengtu_ios' : '') : ($isInIos() ? 'ios' : '')
/**
 * 获取活动参数配置
 */
export const getActivitys = () => axios('portalNoGuid', 'activities/blindBox', 'GET', {}, {}, 200)

export const getPortalConfig = function (path) {
  return new Promise((resolve) => {
    let mHead = document.getElementsByTagName('HEAD').item(0)

    let mScript = document.createElement('script')

    mScript.type = 'text/javascript'

    mScript.src = `${baseUrl.portalConfig}${path}Ratio/ratio.js?time=${new Date().getTime()}`

    mHead.appendChild(mScript)

    mScript.onload = function () {
      resolve()
    }
  })
}

/**
 * 兑换礼包
 * @param {*} userId
 * @param {*} couponId
 */
export const postCouponByCouponId = (userId, couponId) => axios('baseV2', 'users/' + encodeURIComponent(userId) + '/coupons/' + couponId, 'POST', {}, { jwtToken: true, accessToken: true, wsse: true }, 202)

/**
 * 兑换全部礼包
 * @param {*} userId
 * @param {*} activityId
 */
export const postCouponByActivityId = (userId, activityId) => axios('base', 'users/' + encodeURIComponent(userId) + '/batch_obtain/' + activityId, 'POST', {}, { jwtToken: true, accessToken: true, wsse: true }, 202)


/**
 * 
 * @param {*} userId
 * @param {*} couponId
 */

/**
 * 获取礼包列表
 */
export const getCouponList = () => axios('baseV2', 'coupons?entranceType=android_h5&channel='+channel, 'GET', {}, { jwtToken: true, accessToken: true, wsse: true }, 200)

/**
 * 请求用户礼包历史数据（包括未兑换状态）
 * @param {*} userId
 */
export const getCouponsByUserId = (userId) => axios('baseV2', 'users/' + encodeURIComponent(userId) + '/history/coupons', 'GET', {}, { jwtToken: true, accessToken: true, wsse: true }, 200)


/**
 * 请求用户CDK历史数据（包括未兑换状态）
 * @param {*} userId
 */
export const getCDKHisByUserId = (userId) => axios('base', 'users/' + encodeURIComponent(userId) + '/cdkeyHistory?appType='+appType, 'GET', {}, { jwtToken: true, accessToken: true, wsse: true }, 200)

/**
 * 兑换CDK
 * @param {*} userId
 * @param {*} ckdId
 */
export const exchangeCDK = (userId, ckdId, param) => axios('base', 'users/' + encodeURIComponent(userId) + '/cdkey/' + ckdId+ '?appType='+appType, 'POST', param, { jwtToken: true, accessToken: true, wsse: true }, 202)

/**
 * 获取短信验证码
 */
// export const getVerificationCode = (phoneInfo) => axios('baseV4', 'verification_codes?appType=android&entrance=h5_login&service=game_console', 'POST', phoneInfo, {
//   wsse: true
// }, 202)

/**
 * 登录
 */
export const login = (phoneInfo) => axios('gateway', 'sessions/access?version=5.1.13&grant_type=short_message&service=game_console' + ($isInIos() ? '&channel=ios' : ''), 'POST', phoneInfo, {
  wsse: true
}, 202)

/**
 * 获取产品列表
 */
export const getProductList = () => axios('base', 'exploration/products?service=familyMember' + ($isInIos() ? '&channel=ios' : ''))

/**
 * 获取订单列表
 */
export const getOrdersList = (userid) => axios('base', 'exploration/accounts/' + encodeURIComponent(userid) + '/orders?service=familyMember', 'GET', {}, {
  jwtToken: true
})

/**
 * 获取用户家庭会员信息
 */
export const getAccountsInfo = (userid) => axios('base', 'exploration/accounts/' + encodeURIComponent(userid) + '?service=familyMember', 'GET', {}, {
  jwtToken: true
})

/**
 * 获取订单
 */
export const getOrder = (orderId) => axios('base', 'exploration/orders/' + encodeURIComponent(orderId), 'GET', {}, {
  jwtToken: true
})

/**
 * 创建订单
 */
export const createOrder = (info) => axios('base', 'orders' , 'POST', info, {
  jwtToken: true
}, 201)

/**
 * 预支付
 */
export const payment = (info, orderId) => axios('base', 'exploration/orders/' + encodeURIComponent(orderId) + '/payment', 'POST', info, {
  jwtToken: true
}, 201)

/**
 * 查询变更邮箱历史记录
 */
export const getMailboxHistory = (mailbox) => axios('base', 'exploration/mails/' + encodeURIComponent(mailbox) + '/history', 'GET', {}, {
  jwtToken: true
})

/**
 * 更换邮箱/重发邮件
 */
export const getOperateMailbox = (info, orderId) => axios('base', 'exploration/orders/' + encodeURIComponent(orderId) + '/mailbox', 'POST', info, {
  jwtToken: true
})

/**
 * 获取单个邮箱信息
 */
export const getProductType = (mailbox) => axios('base', 'exploration/mails/' + encodeURIComponent(mailbox), 'GET', {}, {
  jwtToken: true
})

/**
 * 获取Openid
 */
export const getOpenId = (codeInfo) => axios('wechat', 'authorization', 'POST', codeInfo, {}, 201)


/**
 * 完成任务
 * /api/:version/:type/users/:userID/tasks/:taskID
 * @param {*} userId
 * @param {*} taskId
 */
export const postTaskByTaskId = (userId, taskId, params) => axios('baseV2', `users/${encodeURIComponent(userId)}/tasks/${encodeURIComponent(taskId)}`, 'POST', params, { jwtToken: true, accessToken: true, wsse: true }, 202)

/**
 * 获取用户列表
 * /api/:version/:type/users/:userID/tasks/:taskID
 * @param {*} userId
 */
export const getTasksByUserId = (userId) => axios('baseV2', 'users/'+ encodeURIComponent(userId) +'/tasks?channel='+channel, 'GET', {}, { jwtToken: true, accessToken: true, wsse: true }, 200)

/**
 * 获取livelink绑定信息接口
 *  /api/:version/:appType/users/:userId/livelink/bind_info
 * @param {*} userId
 */
export const getLiveLinkAccountInfo = (userId) => axios('base', `users/${encodeURIComponent(userId)}/livelink/bind_info`, 'GET', {}, { jwtToken: true, accessToken: true, wsse: true }, 200)

/**
 * 上传用户小程序启动参数
 * /api/:version/:appType/users/:userId/livelink/mini_program_launch
 * @param {*} userId
 */
export const postMiniProgram = (userId, gameId, actId) => axios('base', `users/${encodeURIComponent(userId)}/livelink/mini_program_launch?gameId=${gameId}&actId=${actId}`, 'POST', {}, { jwtToken: true, accessToken: false, wsse: true }, 201)